import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=5a8e4391&scoped=true&"
import script from "./Companies.vue?vue&type=script&lang=ts&"
export * from "./Companies.vue?vue&type=script&lang=ts&"
import style0 from "./Companies.vue?vue&type=style&index=0&id=5a8e4391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e4391",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8e4391')) {
      api.createRecord('5a8e4391', component.options)
    } else {
      api.reload('5a8e4391', component.options)
    }
    module.hot.accept("./Companies.vue?vue&type=template&id=5a8e4391&scoped=true&", function () {
      api.rerender('5a8e4391', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Companies.vue"
export default component.exports